"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class Audit extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'audit';
        this._installerAccountId = initParams.installer_account_id;
        this._installingForId = initParams.installing_for_id;
        this._installerName = initParams.installer_name;
        this._installerOrgName = initParams.installer_org_name;
        this._siteName = initParams.site_name;
        this._siteId = initParams.site_id;
        this._issues = initParams.issues;
        this._warningLevel = initParams.warning_level;
        this._createdDate = initParams.created_date;
        this._message = initParams.message;
        this._devices = (0, util_1.camelArray)(initParams.devices);
        this._gateways = (0, util_1.camelArray)(initParams.gateways);
        this._files = (0, util_1.camelArray)(initParams.files);
        this._warningLevelDevices = initParams.warning_level_devices;
        this._zeroDemandDevices = initParams.zero_demand_devices;
        this._disconnectedDevices = initParams.disconnected_devices;
        this._disconnectedGateways = initParams.disconnected_gateways;
        this._warningLevelGateways = initParams.warning_level_gateways;
        this._warningLevelFiles = initParams.warning_level_files;
    }
    set installerAccountId(value) {
        console.error('Do not set objects this way');
    }
    get installerAccountId() {
        return this._installerAccountId;
    }
    set installingForId(value) {
        console.error('Do not set objects this way');
    }
    get installingForId() {
        return this._installingForId;
    }
    set installerName(value) {
        console.error('Do not set objects this way');
    }
    get installerName() {
        return this._installerName;
    }
    set installerOrgName(value) {
        console.error('Do not set objects this way');
    }
    get installerOrgName() {
        return this._installerOrgName;
    }
    set siteName(value) {
        console.error('Do not set objects this way');
    }
    get siteName() {
        return this._siteName;
    }
    set siteId(value) {
        console.error('Do not set objects this way');
    }
    get siteId() {
        return this._siteId;
    }
    set issues(value) {
        console.error('Do not set objects this way');
    }
    get issues() {
        return this._issues;
    }
    set warningLevel(value) {
        console.error('Do not set objects this way');
    }
    get warningLevel() {
        return this._warningLevel;
    }
    set createdDate(value) {
        console.error('Do not set objects this way');
    }
    get createdDate() {
        return this._createdDate;
    }
    set message(value) {
        console.error('Do not set objects this way');
    }
    get message() {
        return this._message;
    }
    set devices(value) {
        console.error('Do not set objects this way');
    }
    get devices() {
        return this._devices;
    }
    set gateways(value) {
        console.error('Do not set objects this way');
    }
    get gateways() {
        return this._gateways;
    }
    set files(value) {
        console.error('Do not set objects this way');
    }
    get files() {
        return this._files;
    }
    set warningLevelDevices(value) {
        console.error('Do not set objects this way');
    }
    get warningLevelDevices() {
        return this._warningLevelDevices;
    }
    set zeroDemandDevices(value) {
        console.error('Do not set objects this way');
    }
    get zeroDemandDevices() {
        return this._zeroDemandDevices;
    }
    set disconnectedDevices(value) {
        console.error('Do not set objects this way');
    }
    get disconnectedDevices() {
        return this._disconnectedDevices;
    }
    set disconnectedGateways(value) {
        console.error('Do not set objects this way');
    }
    get disconnectedGateways() {
        return this._disconnectedGateways;
    }
    set warningLevelGateways(value) {
        console.error('Do not set objects this way');
    }
    get warningLevelGateways() {
        return this._warningLevelGateways;
    }
    set warningLevelFiles(value) {
        console.error('Do not set objects this way');
    }
    get warningLevelFiles() {
        return this._warningLevelFiles;
    }
}
exports.default = Audit;
//# sourceMappingURL=audit.js.map